import { render, staticRenderFns } from "./PunchGameGoalDonut.vue?vue&type=template&id=5a2378f9&scoped=true&"
import script from "./PunchGameGoalDonut.vue?vue&type=script&lang=js&"
export * from "./PunchGameGoalDonut.vue?vue&type=script&lang=js&"
import style0 from "./PunchGameGoalDonut.vue?vue&type=style&index=0&id=5a2378f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2378f9",
  null
  
)

export default component.exports